import React from 'react';
import ButtonWhite from '../../../../components/ButtonWhite/ButtonWhite';
import { useTranslation } from 'react-multi-lang';

const DeleteConfirmation = ({
    onCancel,
    onDelete
}) => {
    const t = useTranslation();
    return (
        <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
                className="fixed inset-0 w-full h-full bg-black opacity-40"
                onClick={() => onCancel()}
            />
            <div className="flex items-center min-h-screen px-4 py-8">
                <div className="relative w-full max-w-lg p-4 mx-auto bg-gray-primary rounded-xl shadow-lg">
                    <h3 className="text-green-primary font-bold mb-1">Delete product</h3>
                    <p className=" text-[#7D8786] font-['Plus_Jakarta_Sans'] font-medium text-sm tracking-normal">
                        Are you sure you want to delete the product? By doing so, the product will be not in the list.
                    </p>
                    <div className="flex justify-end gap-2 mt-3">
                        <ButtonWhite
                            title={t("general.cancel")}
                            onClick={() => onCancel()}
                        />
                        <button
                            onClick={() => onDelete()}
                            className={`button md:w-36 hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl py-2`}
                        >
                            {t("general.confirm")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmation;